export default "__VITE_ASSET__CHuWZV8B__"